import React, { useState, useRef } from 'react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BusinessGrowthCatalyst() {
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const sectionRef = useRef<HTMLElement>(null);
  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!sectionRef.current) return;
    const rect = sectionRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    setMousePos({
      x,
      y
    });
  };
  return <section data-section-id="18457" id="excellence-in-workforce" ref={sectionRef} onMouseMove={handleMouseMove} className="hero-section dark text-white relative w-full overflow-hidden flex items-end justify-center pb-12 min-h-[520px] pt-12 md:pb-16 md:min-h-[750px] md:pt-20">
      <style dangerouslySetInnerHTML={{
      __html: `
        .hero-section { 
          background: linear-gradient(135deg, #0F172A 0%, #1e293b 100%);
        }
      `
    }} />
      
      <div className="absolute inset-0 z-0 bg-background/75 pointer-events-none" />

      <div className="relative z-10 container mx-auto px-6 flex flex-col items-center text-center">
        <h1 className="text-5xl font-bold text-white leading-[1.1] tracking-tight drop-shadow-2xl max-w-5xl mb-8 !font-sans md:text-7xl lg:text-[84px]">
          We Control Compliance, Workforce &amp; Site Logistics
          <div>for Data Centers and Pharmaceutical Projects.</div>
        </h1>

        <div className="flex flex-col items-center gap-4">
          <p className="font-sans text-white/90 font-medium tracking-wide max-w-2xl !text-lg">&nbsp;Real compliance. Real workforce. <br />We operate where failures are not an option.</p>
          <Button asChild className="mt-2 bg-[#F89406] hover:bg-[#F89406]/90 text-white rounded-[3px] px-10 py-6 text-base font-sans font-bold shadow-[0_0_20px_rgba(248,148,6,0.3)] uppercase tracking-wider border-none cursor-pointer">
            <Link to="/ContactPage">Get in Touch</Link>
          </Button>
        </div>
      </div>
    </section>;
}